export interface TestIdProps {
  'data-testid'?: string;
}
